// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* contact-form.component.css */


@media (max-width: 1080px) {
    form {
        max-width: 400px;       
        /* margin-top: 10%; */
        margin-left: 1%;
        margin-right: 1%; 
      }
}


form {
  /* margin-top: 10% !important; */
  /*margin-left: 10% !important;*/
  max-width: 400px;    
  margin: 0 auto;
  }
  
  input[type="text"],
  input[type="email"],
  textarea {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }

  :host-context(.external-contact-page) .row {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/contact-form/contact-form.component.css"],"names":[],"mappings":"AAAA,+BAA+B;;;AAG/B;IACI;QACI,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,gBAAgB;MAClB;AACN;;;AAGA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd;;EAEA;;;IAGE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B","sourcesContent":["/* contact-form.component.css */\r\n\r\n\r\n@media (max-width: 1080px) {\r\n    form {\r\n        max-width: 400px;       \r\n        /* margin-top: 10%; */\r\n        margin-left: 1%;\r\n        margin-right: 1%; \r\n      }\r\n}\r\n\r\n\r\nform {\r\n  /* margin-top: 10% !important; */\r\n  /*margin-left: 10% !important;*/\r\n  max-width: 400px;    \r\n  margin: 0 auto;\r\n  }\r\n  \r\n  input[type=\"text\"],\r\n  input[type=\"email\"],\r\n  textarea {\r\n    width: 100%;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  :host-context(.external-contact-page) .row {\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
